import {EVENTS, EVENT_CATEGORY, LIST, ORIGIN, isTicketed} from '@wix/wix-events-commons-statics'
import {IWixAPI} from '@wix/yoshi-flow-editor'
import {AnyAction} from 'redux'
import {trackEvent} from '../../../../commons/utils/wix-code-api'
import {widgetLoaded as widgetLoadedAction} from '../actions/layout'
import {onLinkNavigatedToPage, rsvpButtonClicked as rsvpButtonClickedAction} from '../actions/navigate-to-page'
import {getRealEvents} from '../selectors/events'
import {State} from '../types/state'

export const userEventsLogger =
  ({wixCodeApi}: {wixCodeApi: IWixAPI}) =>
  ({getState}) =>
  (next: Function) =>
  (action: AnyAction) => {
    switch (action.type) {
      case widgetLoadedAction.toString():
        widgetLoaded(wixCodeApi, getState())
        break
      case onLinkNavigatedToPage.toString():
      case rsvpButtonClickedAction.toString():
        rsvpButtonClicked(wixCodeApi, action)
        break
      default:
        break
    }

    return next(action)
  }

const widgetLoaded = (wixCodeApi: IWixAPI, state: State) => {
  const contents = getRealEvents(state).map(event => ({name: event.title, list: LIST}))
  trackEvent(wixCodeApi, EVENTS.CustomEvent, {
    origin: ORIGIN,
    contents,
    eventCategory: EVENT_CATEGORY,
    eventLabel: ORIGIN,
    event: EVENTS.WidgetView,
  } as any)
}

const rsvpButtonClicked = (wixCodeApi: IWixAPI, action: AnyAction) => {
  const clickedEvent = action.payload.event

  if (isTicketed(clickedEvent)) {
    trackEvent(wixCodeApi, EVENTS.ClickProduct, {origin: ORIGIN, name: clickedEvent.title, list: LIST})
  } else {
    trackEvent(wixCodeApi, EVENTS.CustomEvent, {
      event: 'Name:rsvpClick',
      name: clickedEvent.title,
      eventCategory: EVENT_CATEGORY,
      eventLabel: ORIGIN,
    } as any)
  }
}
